module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.title !== undefined && _vm.title.length !== 0) ? _c('h2', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeValue),
      expression: "storeValue"
    }],
    staticClass: "configurator__input",
    attrs: {
      "spellcheck": "false",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.storeValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.storeValue = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-940c8cfa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuratorInput.vue
// module id = 70
// module chunks = 0